import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { CRM } from 'src/app/models/crm/crmfunil';
import { CRMAtividade } from 'src/app/models/crm/crmatividade';
import { CRMFiltroAtividade } from 'src/app/models/crm/crmfiltro-atividade';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CrmService } from 'src/app/services/crm/crm.service';
import { CrmatividadeService } from 'src/app/services/crm/crmatividade.service';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { FiltroAtividadeComponent } from '../filtro-atividade/filtro-atividade.component';
import { CadastrarAtividadeComponent } from '../cadastrar-atividade/cadastrar-atividade.component';
import { LogOportunidadeComponent } from '../../oportunidade/log-oportunidade/log-oportunidade.component';
import { CRMHierarquiaUsuarioService } from 'src/app/services/crmhierarquia-usuario.service';
import { FuncionariosModalComponent } from '../../modals/funcionarios-modal/funcionarios-modal.component';
import { Funcionario } from 'src/app/models/funcionario';
import { CRMPesoAtividade } from 'src/app/models/enum';
import { CalendarioAtividadeComponent } from '../calendario-atividade/calendario-atividade.component';

declare const $: any;

export interface TransferenciaAtividade {
  idUsuario: Number;
  atividades: CRMAtividade[];
}

@Component({
  selector: 'app-lista-atividade',
  templateUrl: './lista-atividade.component.html',
  styleUrls: ['./lista-atividade.component.scss']
})
export class ListaAtividadeComponent implements OnInit {
  // variáveis
  carregando = true;
  campoOrdenacao = 'datahora';
  ordenarDesc = false;
  editavel = true;
  crms: CRM[] = [];
  crmSelecionado;
  estaNaHierarquia = false;
  datePipe = new DatePipe('pt-BR');
  suporte = false;
  somenteDonoEditar = false;
  administrador = false;
  selecaoTodos = false;

  idUsuarioAtual = 0;

  atividades: CRMAtividade[] = [];

  filtroAtividade: CRMFiltroAtividade = {
    idCRM: 0, status: -1, statusOportunidade: -1, idTipoAtividade: 0, oportunidade: '', periodo: 0,
    dtInicio: new Date(), dtFim: new Date(), usuarios: [-1], alerta: 0, peso: CRMPesoAtividade.Neutro, cliente: null
  };

  constructor(
    private atividadeService: CrmatividadeService,
    private utilitarioService: UtilitarioService,
    private router: Router,
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private relatorioService: RelatorioService,
    private crmService: CrmService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    public dialog: MatDialog,
    private funcionarioService: FuncionarioService,
    private premissasService: PremissasService
  ) { }

  async ngOnInit() {
    this.suporte = await this.globalService.suporte();
    this.administrador = await this.globalService.administrador();
    this.idUsuarioAtual = Number((await this.globalService.consultaUsuario()).id);

    if (localStorage.getItem('filtroAtividade') !== null) {
      this.filtroAtividade = JSON.parse(localStorage.getItem('filtroAtividade'));
    }

    // verifica configuração da empresa
    this.carregandoService.mostra('buscaConfEmpresa');
    this.premissasService.crmEditarAtividade().subscribe(resp => {
      this.carregandoService.esconde('buscaConfEmpresa');

      this.somenteDonoEditar = resp.valor;

    }, (erro) => {
      this.carregandoService.esconde('buscaConfEmpresa');
      this.notificacaoService.erro(erro);
    });

    this.verificaExistenciaNaHierarquia();
    this.buscarFuncionario();
  }

  selecionarTodos() {
    this.atividades.forEach(p => p.checado = this.selecaoTodos);
  }

  existeItensChecados() {
    return this.atividades.some(p => p.checado);
  }

  async buscarFuncionario() {
    this.carregandoService.mostra('buscarFuncionario');

    this.funcionarioService.consultarFuncionarioPorId(this.idUsuarioAtual).subscribe(resp => {
      this.crmSelecionado = 0;

      this.buscarCRMs();

      this.carregandoService.esconde('buscarFuncionario');
    }, (erro) => {
      this.carregandoService.esconde('buscarFuncionario');
      this.notificacaoService.erro(erro);
    });
  }

  buscarStatusBadge(atividade: CRMAtividade) {
    switch (atividade.status) {
      case 0:
        return 'text-info';
      case 1:
        if (atividade.peso === CRMPesoAtividade.Negativo) {
          return 'text-danger';
        } else if (atividade.peso === CRMPesoAtividade.Positivo) {
          return 'text-success';
        } else {
          return 'text-success';
        }
      case 2:
        return 'text-danger';
      default:
        break;
    }
  }

  buscarStatus(atividade: CRMAtividade) {
    switch (atividade.status) {
      case 0:
        return 'Em andamento';
      case 1:
        if (atividade.peso === CRMPesoAtividade.Negativo) {
          return atividade.tipoAtividade.habilitaPerda ? atividade.tipoAtividade.textoPerda : 'Realizada Negativamente';
        } else if (atividade.peso === CRMPesoAtividade.Positivo) {
          return atividade.tipoAtividade.habilitaGanho ? atividade.tipoAtividade.textoGanho : 'Realizada Positivamente';
        } else {
          return 'Realizada';
        }
      case 2:
        return 'Excluída';
      default:
        break;
    }
  }

  formataData(data, formato) {
    return this.datePipe.transform(new Date(data), formato);
  }

  verificaExistenciaNaHierarquia() {
    this.carregandoService.mostra('verificaHierarquia');

    this.hierarquiaService.usuarioDentroDaHierarquia().subscribe(resp => {
      this.carregandoService.esconde('verificaHierarquia');

      if (!resp) {
        swal({
          title: 'Atenção!!!',
          text: 'Você não é membro de nenhum time!!!',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          type: 'warning'
        }).then(() => { });
      } else {
        this.estaNaHierarquia = true;
      }
    }, (erro) => {
      this.carregandoService.esconde('verificaHierarquia');
      this.notificacaoService.erro(erro);
    });
  }

  buscarAtividadesLista() {
    if (this.crmSelecionado === undefined || this.crmSelecionado === null) {
      this.atividades = [];
      return;
    }

    this.filtroAtividade.idCRM = this.crmSelecionado;

    localStorage.setItem('filtroAtividade', JSON.stringify(this.filtroAtividade));

    this.campoOrdenacao = 'dataHora';
    this.ordenarDesc = true;

    this.carregandoService.mostra('buscaAtividades');
    this.carregando = true;

    this.atividadeService.consultarAtividadesComFiltro(this.filtroAtividade).subscribe(dados => {
      this.atividades = dados;
      this.carregando = false;
      this.carregandoService.esconde('buscaAtividades');
    }, (erro) => {
      this.carregandoService.esconde('buscaAtividades');
      this.notificacaoService.erro(erro);
    });
  }

  buscarCRMs() {
    this.carregandoService.mostra('buscaCRMs');

    this.crmService.consultarCRM().subscribe(resp => {
      this.crms = resp;

      if (this.crms && this.crms.length > 0) {
        this.crms.unshift({ id: 0, descricao: 'Todos', etapas: [], validaCliente: true, criaProjeto: true, ganharOpVenda: false, textoGanho: 'Positivo', textoPerda: 'Negativo', habilitaGanho: true, habilitaPerda: true, tipoFunil: 0 });

        if (this.crmSelecionado !== undefined && this.crmSelecionado !== null) {
          this.crmSelecionado = this.crms[0].id;
        }

        this.buscarAtividadesLista();
      }

      this.carregandoService.esconde('buscaCRMs');
    }, (erro) => {
      this.carregandoService.esconde('buscaCRMs');
      this.notificacaoService.erro(erro);
    });
  }

  abrirCalendario() {
    this.router.navigate(['calendario_atividade']);
  }

  pesquisarAtividade() {
    const filtroTemp = Object.assign({}, this.filtroAtividade);
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(FiltroAtividadeComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { filtro: filtroTemp, crm: this.crms.find(c => c.id == this.crmSelecionado) },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: CRMFiltroAtividade) => {
      if (result) {
        this.filtroAtividade = result;
        this.buscarAtividadesLista();
      }
    });
  }

  editarAtividade(atividade: CRMAtividade) {
    const atividadeParaEditar = new CRMAtividade();
    Object.assign(atividadeParaEditar, atividade);

    const dialogRef = this.dialog.open(CadastrarAtividadeComponent, {
      width: ($('body').width()).toString() + 'px',
      data: { atividade: atividadeParaEditar, idOportunidade: atividade.idOportunidade },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarAtividadesLista();
      }
    });
  }

  excluirAtividade(atividade: CRMAtividade) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Atividade?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiAtividade');
        this.atividadeService.excluir(atividade.id).subscribe(resp => {

          this.notificacaoService.sucesso('Atividade excluído com sucesso!!!');
          this.carregandoService.esconde('excluiAtividade');
          this.buscarAtividadesLista();

        }, (erro) => {
          this.carregandoService.esconde('excluiAtividade');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  finalizarAtividade(atividade: CRMAtividade, tipoConclusao: CRMPesoAtividade) {
    atividade.peso = tipoConclusao;

    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente finalizar a Atividade?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        atividade.status = 1;

        this.carregandoService.mostra('salvaAtividade');
        this.atividadeService.alterarStatus(atividade).subscribe(resp => {

          this.notificacaoService.sucesso('Atividade salva com sucesso!!!');
          this.carregandoService.esconde('salvaAtividade');
          this.buscarAtividadesLista();

        }, (erro) => {
          this.carregandoService.esconde('salvaAtividade');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  reativarAtividade(atividade: CRMAtividade) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente reativar a Atividade?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        atividade.status = 0;

        this.carregandoService.mostra('salvaAtividade');
        this.atividadeService.alterarStatus(atividade).subscribe(resp => {

          this.notificacaoService.sucesso('Atividade salva com sucesso!!!');
          this.carregandoService.esconde('salvaAtividade');
          this.buscarAtividadesLista();
        }, (erro) => {
          this.carregandoService.esconde('salvaAtividade');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  ngOnDestroy(): void { }

  atividadeVencida(atividade: CRMAtividade) {
    const resultado = this.utilitarioService.retornaDiferencaDeDias(new Date(atividade.dataHora),
      atividade.status === 0 ? new Date() : new Date(atividade.dtStatus));

    return resultado === 0 ? 'text-warning' : resultado < 0 ? 'text-danger' : 'text-success';
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.atividades = this.atividades.sort((a, b) => {
        const isAsc = !this.ordenarDesc;

        switch (this.campoOrdenacao) {
          case 'tipoAtividade': return this.compare(a.tipoAtividadeDescricao, b.tipoAtividadeDescricao, isAsc);
          case 'contato': return this.compare(a.contatoNome, b.contatoNome, isAsc);
          case 'oportunidade': return this.compare(a.oportunidadeTitulo, b.oportunidadeTitulo, isAsc);
          case 'alerta': return this.compare(this.atividadeVencida(a), this.atividadeVencida(b), isAsc);
          case 'usuario': return this.compare(a.nomeUsuario, b.nomeUsuario, isAsc);
          case 'dtCriacao': return this.compare(Number(new Date(a.dtCriacao)), Number(new Date(b.dtCriacao)), isAsc);
          case 'dataHora': return this.compare(Number(new Date(a.dataHora)), Number(new Date(b.dataHora)), isAsc);
          case 'status': return this.compare(this.buscarStatus(a), this.buscarStatus(b), isAsc);
          default: return 0;
        }
      });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  abrirLogDaAtividade(atividade: CRMAtividade) {
    const dialogRef = this.dialog.open(LogOportunidadeComponent, {
      width: ($('body').width()).toString() + 'px',
      data: { idOportunidade: atividade.idOportunidade, idAtividade: atividade.id, atividade },
      panelClass: 'modal-card'
    });
  }

  enviarAlertas() {
    this.carregandoService.mostra('enviarAlertas');

    this.atividadeService.enviarAlertas().subscribe(resp => {
      this.notificacaoService.sucesso('Alertas enviados com sucesso!!!');
      this.carregandoService.esconde('enviarAlertas');
    }, (erro) => {
      this.carregandoService.esconde('enviarAlertas');
      this.notificacaoService.erro(erro);
    });
  }

  restaurarFiltros() {
    this.filtroAtividade = {
      idCRM: 0, status: -1, statusOportunidade: -1, idTipoAtividade: 0, oportunidade: '', periodo: 0,
      dtInicio: new Date(), dtFim: new Date(), usuarios: [-1], alerta: 0, peso: CRMPesoAtividade.Neutro, cliente: null
    };

    this.buscarAtividadesLista();
  }

  editarOportunidade(id) {
    this.router.navigate(['/crm/oportunidades/editar', id]);
  }

  gerarRelatorio(exportacao: number) {
    this.filtroAtividade.exportacao = exportacao;
    this.filtroAtividade.idCRM = this.crmSelecionado;

    this.carregandoService.mostra('relatorioAtividade');

    this.relatorioService.relatorioDeAtividades(this.filtroAtividade).subscribe(resp => {
      if (exportacao === 0) {
        this.utilitarioService.openBlob(resp);
      }
      else {
        this.notificacaoService.sucesso('Relatório gerado com sucesso!!!');
        this.utilitarioService.saveBlob(resp, 'Atividades.xlsx');
      }

      this.carregandoService.esconde('relatorioAtividade');
    }, (erro) => {
      const reader = new FileReader();

      // This fires after the blob has been read/loaded.
      reader.addEventListener('loadend', (e) => {
        const text = e.srcElement['result'];
        this.carregandoService.esconde('relatorioAtividade');
        this.notificacaoService.erro(text);
      });

      // Start reading the blob as text.
      reader.readAsText(erro.error);
    });
  }

  trocarUsuario() {
    const dialogRef = this.dialog.open(FuncionariosModalComponent, {
      width: ($('body').width()).toString() + 'px',
      data: { trabalharComCheckBox: true, mostrarBotoes: false, mostrarSomenteDoFunil: true },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe((result: Funcionario[]) => {
      if (result) {
        const transferencias: TransferenciaAtividade[] = [];

        const atividadesParaTransferir = this.atividades.filter(p => p.checado);
        const qtd = atividadesParaTransferir.length;

        let qtdCada = Math.floor(qtd / result.length);
        let resto = qtd % result.length;
        let texto = 'Deseja realmente transferir ';
        let qtdPega = 0;

        for (let index = 0; index < result.length; index++) {
          let qtdParaPegar = qtdCada;
          if (index === 0 && qtdCada > 0) {
            qtdParaPegar += resto;
          } else if (qtdCada === 0 && resto > 0) {
            qtdParaPegar++;
            resto--;
          }

          if (qtdPega < qtd) {
            texto += (index > 0 && index === result.length - 1 ? ' e ' : (index > 0 ? ', ' : '')) + qtdParaPegar + ' atividade' + (qtdParaPegar == 1 ? '' : 's') + ' para o usuário ' + result[index].nome;
            transferencias.push({ idUsuario: Number(result[index].idFuncion), atividades: atividadesParaTransferir.slice(qtdPega, qtdPega + qtdParaPegar) });
            qtdPega += qtdParaPegar;
          }
        }

        swal({
          title: 'ATENÇÃO!',
          text: texto + '?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-info',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          buttonsStyling: false
        }).then((res) => {
          if (res.value) {
            this.carregandoService.mostra('trocarUsuario');

            this.atividadeService.trocarUsuario({ transferencias: transferencias }).subscribe(resp => {

              this.notificacaoService.sucesso('Transferência executada com sucesso!!!');

              this.buscarAtividadesLista();

              this.carregandoService.esconde('trocarUsuario');
            }, (erro) => {
              this.carregandoService.esconde('trocarUsuario');
              this.notificacaoService.erro(erro);
            });
          }
        });
      }
    });
  }
}
